export default __webpack_public_path__ + "cc36650d428511e21afe2b9d029f4e7d.svg";